// extracted by mini-css-extract-plugin
module.exports = {"statistic_container":"index_statistic_container__2gi2M","row_item":"index_row_item__3YL_S","logo":"index_logo__1TKoS"};